import PropTypes from 'prop-types'

import {
  Box, ListItem, Text,
} from '@domain-group/suit-theme'

const BrandSystemColourListItem = (props) => {
  const { colour, text } = props

  if (!colour) return null

  return (
    <ListItem
      boxProps={{
        alignItems: 'center', borderBottom: '1px dashed', fontSize: 'small', padding: 'large',
      }}
      disableHover
    >
      <Box
        backgroundColor={`#${colour}`}
        border="1px solid"
        borderColor="lineColor"
        borderRadius="50%"
        flexShrink={0}
        height={18}
        marginRight="large"
        width={18}
      />

      <Box flexDirection="column">
        <Text color="bodyFontColor" variant="ellipsis">
          #{colour}
        </Text>

        <Text color="bodyFontLightColor" variant="ellipsis">
          {text}
        </Text>
      </Box>
    </ListItem>
  )
}

BrandSystemColourListItem.propTypes = {
  colour: PropTypes.string,
  text: PropTypes.string,
}

export default BrandSystemColourListItem
